import * as TypeGraphQL from "type-graphql";
export var EconomicEventScalarFieldEnum;
(function (EconomicEventScalarFieldEnum) {
    EconomicEventScalarFieldEnum["id"] = "id";
    EconomicEventScalarFieldEnum["title"] = "title";
    EconomicEventScalarFieldEnum["description"] = "description";
    EconomicEventScalarFieldEnum["date"] = "date";
    EconomicEventScalarFieldEnum["importance"] = "importance";
    EconomicEventScalarFieldEnum["createdAt"] = "createdAt";
    EconomicEventScalarFieldEnum["updatedAt"] = "updatedAt";
})(EconomicEventScalarFieldEnum || (EconomicEventScalarFieldEnum = {}));
TypeGraphQL.registerEnumType(EconomicEventScalarFieldEnum, {
    name: "EconomicEventScalarFieldEnum",
    description: undefined,
});
//# sourceMappingURL=EconomicEventScalarFieldEnum.js.map